import React from "react";
import { Query } from "react-apollo";
import gql from "graphql-tag";
import HistoryRdvModalContent from "./HistoryRdvModalContent";
import update from "immutability-helper";

class HistoryRdvModal extends React.Component {
  static defaultProps = {
    hasRdv: false
  };
  constructor(props) {
    super(props);
    this.state = {
      tab: props.hasRdv ? 2 : 0
    };
  }

  render() {
    let patientId = this.props.patientId;
    return (
      <div>
        <Query
          query={GET_PATIENT}
          variables={{
            patientId
          }}
        >
          {({ loading, error, data, subscribeToMore }) => {
            let patient = data.Patient;

            return (
              <HistoryRdvModalContent
                {...this.props}
                loading={loading}
                tab={this.state.tab}
                patient={patient}
                subscribeToPatient={patientId => {
                  return subscribeToMore({
                    document: PATIENT_SUBSCRIPTION,
                    variables: { patientId },
                    updateQuery: (prev, { subscriptionData }) => {
                      if (!subscriptionData.data) return prev;
                      const newPatient = subscriptionData.data.Patient.node;

                      return update(prev, {
                        Patient: {
                          comment: { $set: newPatient.comment },
                          updatedAt: { $set: newPatient.updatedAt }
                        }
                      });

                      /*return Object.assign({}, prev, {
                        Patient: {
                          comment: newPatient.comment
                        }
                      });*/
                    }
                  });
                }}
              />
            );
          }}
        </Query>
      </div>
    );
  }
}

const PATIENT_SUBSCRIPTION = gql`
  subscription onPatientChange($patientId: ID!) {
    Patient(filter: { mutation_in: [UPDATED], node: { id: $patientId } }) {
      mutation
      previousValues {
        id
      }
      updatedFields
      node {
        id
        comment
        updatedAt
      }
    }
  }
`;

const GET_PATIENT = gql`
  query GetPatient($patientId: ID!) {
    Patient(id: $patientId) {
      id
      updatedAt
      nom
      prenom
      matricule
      comment
      telephone
      portable
      adresse
      codepostal
      email
      ville
      slots(orderBy: startTime_DESC) {
        startTime
        status
        takenBy
        comment
        canceledBy
        slotType {
          name
        }
        updatedAt
        createdAt
      }
    }
  }
`;

export default HistoryRdvModal;



// WEBPACK FOOTER //
// ./src/components/utilities/HistoryRdvModal.js